// Color Palette Configuration
export const colorPalette = {
    light: {
        primary: {
            main: '#2D3436', // Dark Gray (Primary)
            light: '#636E72',
            dark: '#1E272E',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#0984E3', // Electric Blue
            light: '#74B9FF',
            dark: '#0770C0',
            contrastText: '#FFFFFF',
        },
        accent: {
            main: '#00B894', // Mint
            light: '#55EFC4',
            dark: '#00A07A',
            contrastText: '#FFFFFF',
        },
        text: {
            primary: '#2D3436', // Dark Gray
            secondary: '#636E72',
            disabled: '#B2BEC3',
        },
        background: {
            default: '#FFFFFF',
            paper: '#F5F6FA',
            gradient: {
                primary: 'linear-gradient(45deg, #2D3436 30%, #0984E3 90%)',
                secondary: 'linear-gradient(45deg, #0984E3 30%, #00B894 90%)',
                accent: 'linear-gradient(45deg, #2D3436 30%, #00B894 90%)',
            },
        },
        divider: 'rgba(45, 52, 54, 0.12)',
    },
    dark: {
        primary: {
            main: '#FFFFFF', // White
            light: '#F5F6FA',
            dark: '#DFE6E9',
            contrastText: '#2D3436',
        },
        secondary: {
            main: '#74B9FF', // Light Electric Blue
            light: '#81ECEC',
            dark: '#0984E3',
            contrastText: '#2D3436',
        },
        accent: {
            main: '#55EFC4', // Light Mint
            light: '#81ECEC',
            dark: '#00B894',
            contrastText: '#2D3436',
        },
        text: {
            primary: '#FFFFFF',
            secondary: '#DFE6E9',
            disabled: '#B2BEC3',
        },
        background: {
            default: '#2D3436',
            paper: '#1E272E',
            gradient: {
                primary: 'linear-gradient(45deg, #FFFFFF 30%, #74B9FF 90%)',
                secondary: 'linear-gradient(45deg, #74B9FF 30%, #55EFC4 90%)',
                accent: 'linear-gradient(45deg, #FFFFFF 30%, #55EFC4 90%)',
            },
        },
        divider: 'rgba(255, 255, 255, 0.12)',
    },
};

// Helper functions for color manipulation
export const colorUtils = {
    // Add alpha channel to hex color
    addAlpha: (hex, alpha) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },

    // Create gradient
    createGradient: (color1, color2) => {
        return `linear-gradient(45deg, ${color1} 30%, ${color2} 90%)`;
    },

    // Create glass effect
    createGlassEffect: (baseColor, alpha = 0.9) => {
        return {
            backgroundColor: colorUtils.addAlpha(baseColor, alpha),
            backdropFilter: 'blur(10px)',
            border: '1px solid',
            borderColor: colorUtils.addAlpha(baseColor, 0.3),
        };
    },
};
